'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const SAMPLE_IDEAS = [
  { title: 'OCR de boletas SII para contadores', tag: 'Finanzas · SaaS' },
  { title: 'CRM para concesionarias vía Yapo.cl', tag: 'Retail · B2B' },
  { title: 'Bot WhatsApp de cobranza para pymes', tag: 'Tecnología · B2B' },
];

const BuildertonSection = ({ className = '' }: { className?: string }) => {
  return (
    <section
      className={`py-10 lg:py-14 relative overflow-hidden ${className}`}
      style={{ background: 'linear-gradient(160deg, #0d1b3e 0%, #1a0930 50%, #0d1b3e 100%)' }}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/4 w-72 h-72 bg-orange-500/8 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-pink-500/8 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-8 items-center">

          {/* Left — copy */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-500/15 border border-orange-400/25 mb-4">
              <span className="text-sm">💡</span>
              <span className="text-xs font-semibold text-orange-300 tracking-wide">Generador de Ideas · Nuevo</span>
            </div>

            <h2 className="text-3xl lg:text-4xl font-black text-white leading-tight mb-3">
              ¿Estás con falta de ideas?{' '}
              <span
                className="bg-clip-text text-transparent"
                style={{ backgroundImage: 'linear-gradient(135deg, #fb923c 0%, #ec4899 100%)' }}
              >
                Genera las tuyas
              </span>{' '}con IA.
            </h2>

            <p className="text-white/65 text-base leading-relaxed mb-6">
              Accede a nuestra pequeña <strong className="text-white">"Builderton"</strong>: filtra por sector e impacto y obtén 10 ideas específicas, rentables y contextualizadas para tu país — con cliente exacto y modelo de ingresos. ¿Qué esperas?
            </p>

            <div className="flex items-center gap-4">
              <Link
                href="/generador"
                className="group inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-white text-sm transition-all duration-200 hover:scale-105 hover:shadow-xl hover:shadow-pink-500/20"
                style={{ backgroundImage: 'linear-gradient(135deg, #fb923c 0%, #ec4899 100%)' }}
              >
                <span>Genera tus ideas con IA</span>
                <Icon name="ArrowRightIcon" size={16} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <p className="text-white/30 text-xs">1 token · Sin compromisos</p>
            </div>
          </div>

          {/* Right — 3 idea cards */}
          <div className="hidden lg:flex flex-col gap-2.5">
            {SAMPLE_IDEAS.map((idea, i) => (
              <div
                key={idea.title}
                className="flex items-center gap-3 px-4 py-3 rounded-xl border border-white/8 bg-white/4 backdrop-blur-sm"
                style={{ opacity: 1 - i * 0.15, transform: `translateX(${i * 10}px)` }}
              >
                <div className="w-7 h-7 rounded-full bg-gradient-to-br from-orange-500 to-pink-500 flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-xs">{i + 1}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white font-medium text-sm truncate">{idea.title}</p>
                  <p className="text-white/35 text-xs">{idea.tag}</p>
                </div>
                <Icon name="ArrowRightIcon" size={13} className="text-white/15 flex-shrink-0" />
              </div>
            ))}
            <p className="text-white/20 text-xs text-right mt-1 pr-1">✨ 10 ideas nuevas · 1 token</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BuildertonSection;
